import React from 'react';
import { PHONE, PHONE_DISPLAY } from '../../data/appData';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export default function Footer() {
  return (
    <footer style={{ background: 'var(--metal-dark)', color: 'rgba(255,255,255,0.7)', position: 'relative', overflow: 'hidden' }}>
      <div style={{ marginBottom: '-2px' }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', width: '100%' }}>
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="var(--bg-primary)"/>
        </svg>
      </div>
      <div style={{ position: 'absolute', top: 0, right: 0, width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(0,180,204,0.08) 0%, transparent 70%)', pointerEvents: 'none' }}/>

      {/* Watermark — footer'ın tam ortası */}
      <img
        src="/logo.png"
        alt=""
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '1040px',
          width: 'auto',
          opacity: 0.07,
          filter: 'grayscale(1) brightness(4) contrast(1.4) drop-shadow(0 0 1px rgba(255,255,255,0.8)) drop-shadow(0 0 2px rgba(255,255,255,0.6)) drop-shadow(0 0 3px rgba(255,255,255,0.4))',
          pointerEvents: 'none',
          userSelect: 'none',
          zIndex: 0,
        }}
      />


      <div className="container" style={{ padding: '64px 24px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '48px', marginBottom: '48px' }}>

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <img
                src="/logo.png"
                alt="Taşgın Tesisat"
                style={{
                  height: '52px',
                  width: 'auto',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 0 8px rgba(0,212,240,0.4)) brightness(1.05)',
                }}
              />
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.2rem', color: 'white', letterSpacing: '-0.02em' }}>TAŞGIN</div>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.6rem', letterSpacing: '0.2em', color: 'var(--teal)', textTransform: 'uppercase' }}>TESİSAT</div>
              </div>
            </div>
            <p style={{ fontSize: '0.9rem', lineHeight: 1.7, marginBottom: '20px' }}>
              18 yıllık deneyim ve ileri teknoloji ile Ankara'nın her köşesinde güvenilir tesisat hizmeti.
            </p>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {['WhatsApp', 'Instagram', 'Facebook', 'YouTube'].map(s => (
                <a key={s} href="#" style={{ padding: '6px 14px', borderRadius: 'var(--radius-full)', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', fontSize: '0.78rem', color: 'rgba(255,255,255,0.6)', transition: 'all 0.2s', cursor: 'pointer' }}>{s}</a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', color: 'white', marginBottom: '20px', fontSize: '0.95rem', letterSpacing: '0.05em' }}>HİZMETLER</h4>
            {['Su Kaçağı Tespiti', 'Tıkanıklık Açma', 'Petek Temizleme', 'Tesisat Yenileme', 'Banyo Renovasyonu', 'Doğalgaz Montajı'].map(s => (
              <button key={s} onClick={() => scrollTo('hizmetler')} style={{ display: 'block', padding: '5px 0', fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)', transition: 'color 0.2s', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}>{s}</button>
            ))}
          </div>

          {/* Kurumsal */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', color: 'white', marginBottom: '20px', fontSize: '0.95rem', letterSpacing: '0.05em' }}>KURUMSAL</h4>
            {[
              { label: 'Hakkımızda', id: 'anasayfa' },
              { label: 'Teknolojilerimiz', id: 'teknolojiler' },
              { label: 'Blog', id: 'blog' },
              { label: 'Müşteri Yorumları', id: 'yorumlar' },
              { label: 'Galeri', id: 'galeri' },
              { label: 'İletişim', id: 'iletisim' },
            ].map(({ label, id }) => (
              <button key={label} onClick={() => scrollTo(id)} style={{ display: 'block', padding: '5px 0', fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)', transition: 'color 0.2s', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}>{label}</button>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', color: 'white', marginBottom: '20px', fontSize: '0.95rem', letterSpacing: '0.05em' }}>İLETİŞİM</h4>
            {[
              { icon: '📞', text: PHONE_DISPLAY },
              { icon: '📱', text: `${PHONE_DISPLAY} (WhatsApp)` },
              { icon: '📍', text: 'Güzelkent Mah. 369. Sok., Ankara' },
              { icon: '🕐', text: 'Pzt–Cmt: 08:00 – 20:00' },
            ].map(({ icon, text }) => (
              <div key={text} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '10px' }}>
                <span>{icon}</span>
                <span style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)' }}>{text}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.35)' }}>
              © 2026 Taşgın Tesisat. Tüm hakları saklıdır.
            </p>
            <div style={{ display: 'flex', gap: '20px' }}>
              {['Gizlilik Politikası', 'Kullanım Koşulları', 'KVKK'].map(t => (
                <span key={t} style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.35)', cursor: 'pointer' }}>{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
